module.exports = __webpack_public_path__ + "img/parking-promo.d2fb7a74.jpg";